import React, { useState } from "react";
import PlanCard from "../../Components/Cards/PlanCard";
import { useNavigate } from "react-router-dom";
import ProgressBar from "../../Components/ProgressBar";

function Plan() {
  const [selectedPlan, setSelectedPlan] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = () => {
    navigate("/Template");
  };

  const plans = [
    {
      id: 1,
      name: "Basic Plan",
      price: "$9.99 / month",
      features: [
        "✔ Limited Access",
        "✔ Email Support",
        "✖ Ads Included",
        "✖ Exclusive Content",
      ],
    },
    {
      id: 2,
      name: "Standard Plan",
      price: "$14.99 / month",
      features: [
        "✔ Full Access",
        "✔ 24/7 Support",
        "✔ No Ads",
        "✖ Exclusive Content",
      ],
    },
    {
      id: 3,
      name: "Premium Plan",
      price: "$19.99 / month",
      features: [
        "✔ Unlimited Access",
        "✔ 24/7 Support",
        "✔ No Ads",
        "✔ Exclusive Content",
      ],
    },
  ];

  return (
    <div className="container-goal">
      <ProgressBar completed={60} className="mt-3"/>
      <h1 className="heading">Find the plan for you</h1>
      <p>You can change at any time</p>
      <div className="plan-container">
        {plans.map((plan) => (
          <PlanCard
            key={plan.id}
            plan={plan}
            isSelected={selectedPlan === plan.id}
            onSelect={() => setSelectedPlan(plan.id)}
          />
        ))}
      </div>
      <div>
        <button className="btn-continue mt-3" onClick={handleSubmit}>
          Continue
        </button>
      </div>
    </div>
  );
}

export default Plan;
